import React, { useEffect } from 'react';
import { CircularProgress } from '@material-ui/core';
import useContact from '../../hooks/api/useContact';

const ContactRedirection = ({ history, match }) => {
  const { id } = match.params;
  const { get } = useContact();

  useEffect(() => {
    if (id) {
      get(id).then((contact) => {
        if (contact.legacyContactId) {
          history.push(`/dashboard/contact/${contact.legacyContactId}`);
        } else {
          history.push(`/dashboard/crm/contacts/${contact.id}`);
        }
      });
    }
  }, [id]);

  return <CircularProgress size={17} />;
};

export default ContactRedirection;
